import { AnimatePresence, motion } from "framer-motion";
import { useLocation, Routes } from "react-router-dom";
import { cloneElement } from "react";

/**
 * Wrap your <Routes>...</Routes> with this. Each route change
 * cross-fades with a subtle slide. 220ms feels premium without
 * making navigation feel sluggish.
 *
 * Usage:
 *   <AnimatedRoutes>
 *     <Routes>...</Routes>
 *   </AnimatedRoutes>
 */
export default function AnimatedRoutes({ children }) {
  const location = useLocation();
  // Inject `location` into the inner <Routes> so React Router can keep
  // the previous route mounted while AnimatePresence animates it out.
  const routesWithLocation =
    children && children.type === Routes
      ? cloneElement(children, { location })
      : children;

  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0, y: 6 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -4 }}
        transition={{ duration: 0.22, ease: [0.22, 1, 0.36, 1] }}
      >
        {routesWithLocation}
      </motion.div>
    </AnimatePresence>
  );
}
